/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewsletterDto } from '../../models/newsletter-dto';

export interface CreateNewsletter$Params {
  serviceTime: number;
  asdNote: string;
      body?: {
'file': Blob;
}
}

export function createNewsletter(http: HttpClient, rootUrl: string, params: CreateNewsletter$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsletterDto>> {
  const rb = new RequestBuilder(rootUrl, createNewsletter.PATH, 'post');
  if (params) {
    rb.query('serviceTime', params.serviceTime, {});
    rb.query('asdNote', params.asdNote, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NewsletterDto>;
    })
  );
}

createNewsletter.PATH = '/newsletter';
